/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import api from "../../../../../app/services/api";
import { getVersion } from "../../../../../app/version";
import { renewMediaToken } from "../../../../../app/mediatoken";
import { getUserAccessLevel } from "../../../../../app/helpers/role";
import { getUser } from "../../../../../index";
import { getUseAPI } from "../../../../../app/modules/Auth/_redux/authCrud";
import { getUserFactoryId } from "../../../../../index";

export function AsideMenuList({ layoutProps }) {
  const [version, setVersion] = useState();
  const [dateVersion, setDateVersion] = useState();
  const [user, setUser] = useState();
  const location = useLocation();
  const [rollout, setRollout] = useState([]);
  const [lppAccess, setLPPAccess] = useState(false);
  const [dtpAccess, setDTPAccess] = useState(false);
  const [idcardAccess, setIdcardAccess] = useState(false);
  const [funilAccess, setFunilAccess] = useState(false);

  const userAcessLevel = getUserAccessLevel();

  useEffect(() => {
    async function getVersionAsync() {
      renewMediaToken();
      let versionToStorage = localStorage.getItem("versioninfo");
      if (versionToStorage !== null) {
        const versionSplited = versionToStorage.split("-", 2);
        setDateVersion(versionSplited[1]);
        setVersion(versionSplited[0]);
      }
    }

    async function getFactoryRollout() {
      const access = await api.get(
        `/rollout/odata?$select=module&$filter=factoryId+eq+${getUserFactoryId()}`,
      );
      setRollout(access.data.value);

      const lpp = access.data.value.find((a) => a.module == "LPP");
      if (lpp || getUserFactoryId() == 1207 || getUserFactoryId() == 1111)
        setLPPAccess(true);

      const dtp = access.data.value.find((a) => a.module == "DTP");
      if (dtp || getUserFactoryId() == 1207 || getUserFactoryId() == 1111)
        setDTPAccess(true);

      const idcard = access.data.value.find((a) => a.module == "Idcard");
      if (idcard || getUserFactoryId() == 1207 || getUserFactoryId() == 1111)
        setIdcardAccess(true);

      const funil = access.data.value.find((a) => a.module == "Funil");
      if (funil || getUserFactoryId() == 1207 || getUserFactoryId() == 1111)
        setFunilAccess(true);
    }

    setUser(getUser());

    //console.log(userAcessLevel)
    if (userAcessLevel >= 1) {
      getVersionAsync();
    }

    getFactoryRollout();
  }, []); // << super important array

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      <>
        {/* begin::Menu Nav */}
        <ul className={`menu-nav flex-grow-1 ${layoutProps.ulClasses}`}>
          {/*begin::1 Level*/}
          <li
            className={`menu-item ${getMenuItemActive("/home", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/home">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
              </span>
              <span className="menu-text">Home</span>
            </NavLink>
          </li>
          {/*end::1 Level*/}

          {/*google*/}
          {userAcessLevel >= 0 && (
            <li
              className={`menu-item ${getMenuItemActive("/buscador", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/buscador">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                  />
                </span>
                <span className="menu-text">Ache Aqui!</span>
              </NavLink>
            </li>
          )}

          {userAcessLevel >= 0 && (
            <li
              className={`menu-item ${getMenuItemActive(
                "/factoryBIassessment",
                false,
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/factoryBIassessment">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/General/Clipboard.svg",
                    )}
                  />
                </span>
                <span className="menu-text">Relatório geral</span>
              </NavLink>
            </li>
          )}

          {userAcessLevel >= 10 && (
            <li
              className={`menu-item ${getMenuItemActive(
                "/factoryassessment",
                false,
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/factoryassessment">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/General/Clipboard.svg",
                    )}
                  />
                </span>
                <span className="menu-text">Relatório geral (nao BI)</span>
              </NavLink>
            </li>
          )}

          {userAcessLevel >= 2 && (
            <li
              className={`menu-item ${getMenuItemActive("/admin", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/admin">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Files/User-folder.svg",
                    )}
                  />
                </span>
                <span className="menu-text">Admin</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Admin</span>
                    </span>
                  </li>

                  {userAcessLevel >= 3 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/stdadmin",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/stdadmin">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Padrões</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 2 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/training-admin",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/training-admin">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Listagem Treinamentos</span>
                      </NavLink>
                    </li>
                  )}
                  {userAcessLevel >= 2 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/training-month",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/training-month">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Treinamentos/Mês</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 2 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/approverreport",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/approverreport">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Ver Aprovadores</span>
                      </NavLink>
                    </li>
                  )}
                  {userAcessLevel >= 9 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/template",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/template">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Templates</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 4 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/companyassessment",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/companyassessment">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Company Assessment</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}

          {userAcessLevel >= 1 && (
            <li
              className={`menu-item ${getMenuItemActive(
                "/standard",
                false,
              )} ${getMenuItemActive("/user/training", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/standard">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")}
                  />
                </span>
                <span className="menu-text">Minhas atividades</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Minhas atividades</span>
                    </span>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/standard",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/standard">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Meus documentos (autor)</span>
                    </NavLink>
                  </li>
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/user/training",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/user/training">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Meus Treinamentos</span>
                    </NavLink>
                  </li>

                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/painelsupervisor",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/painelsupervisor">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Painel do Supervisor</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}
          {lppAccess && (
            <li
              className={`menu-item ${getMenuItemActive("/lpp", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/lpp">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Layout/Layout-top-panel-5.svg",
                    )}
                  />
                </span>
                <span className="menu-text">LPP</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">LPP</span>
                    </span>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/lpp/list",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/lpp/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Lista LPP</span>
                    </NavLink>
                  </li>

                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/lpp/new/0",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/lpp/new/0">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Nova LPP</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}
          {/*end::1 Level*/}

          {/*begin::1 Level DTPs*/}
          {dtpAccess && (
            <li
              className={`menu-item ${getMenuItemActive("/dtp", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/dtp">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Layout/Layout-arrange.svg",
                    )}
                  />
                </span>
                <span className="menu-text">DTP</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">DTP</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/dtp/list",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/dtp/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Lista DTP</span>
                    </NavLink>
                  </li>
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/dtp/new/0",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/dtp/new/0">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Nova DTP</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}

          {idcardAccess && (
            <li
              className={`menu-item ${getMenuItemActive("/idcard", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/idcard">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Ticket.svg")}
                  />
                </span>
                <span className="menu-text">ID Card</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">ID Card</span>
                    </span>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/idcard/list",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/idcard/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Lista ID Card</span>
                    </NavLink>
                  </li>

                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/idcard/new/0",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/idcard/new/0">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Novo ID Card</span>
                      </NavLink>
                    </li>
                  )}
                  {userAcessLevel >= 3 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/product",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/product">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Produtos</span>
                      </NavLink>
                    </li>
                  )}
                  {userAcessLevel >= 3 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/defectcategory",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/defectcategory">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Categorias de defeito</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 3 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/defecttype",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/defecttype">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Tipos de defeito</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/idcard/relatorio",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/idcard/relatorio/1/null"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Relatorio ID Card</span>
                    </NavLink>
                  </li>
                  {userAcessLevel >= 0 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/idcard/ExportDMO",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/idcard/ExportDMO">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Exportar DMO</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 2 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/idcard/history",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/idcard/history">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Dados histórico</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}
                </ul>
              </div>
            </li>
          )}
          {/*end::1 Level*/}

          {/*begin::1 Level Material treinamento*/}
          <li
            className={`menu-item ${getMenuItemActive(
              "/trainingmaterial",
              false,
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/trainingmaterial">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Home/Book-open.svg")}
                />
              </span>
              <span className="menu-text">Biblioteca de Treinamento</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text">Material de Treinamento</span>
                  </span>
                </li>

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/trainingmaterial",
                    false,
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/trainingmaterial">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      Lista biblioteca de treinamento
                    </span>
                  </NavLink>
                </li>
                {userAcessLevel >= 1 && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/trainingmaterial/new/0",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/trainingmaterial/new/0">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        Novo material de treinamento
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>

          {userAcessLevel >= 0 && (
            <li
              className={`menu-item ${getMenuItemActive("/externaltraining", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/externaltraining">
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Book.svg")} />
                </span>
                <span className="menu-text">Biblioteca Documentos</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                <li
                    className={`menu-item ${getMenuItemActive(
                      "/externaldocumentlist",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/externaldocumentlist">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Lista de Documentos Externos</span>
                    </NavLink>
                  </li>
                {userAcessLevel >= 7 &&
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/externaltraining",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/externaltraining">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Cadastrar Treinamentos (ILearn)</span>
                    </NavLink>
                  </li>
                  }
                  {userAcessLevel >= 7 &&
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/externaldocumentqms",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/externaldocumentqms">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Cadastrar Documentos DMS</span>
                    </NavLink>
                  </li>
                  }
                  {userAcessLevel >= 7 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/ExternalDocumentPilarPage",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/ExternalDocumentPilarPage">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Cadastrar Documentos Pilares</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}

          {funilAccess && (
            <li
              className={`menu-item ${getMenuItemActive("/funnel", false)}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/funnel">
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Funil.svg")} />
                </span>
                <span className="menu-text">Funil</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Funil</span>
                    </span>
                  </li>

                  {/*begin::2 Level*/}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/funnel/list",
                      false,
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/funnel/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">Lista Funis</span>
                    </NavLink>
                  </li>
                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/funnel/new/0",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/funnel/new/0">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Novo Funil</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/funnel/relatfabrica",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/funnel/relatfabrica/null"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Factory Assessment Funil
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {userAcessLevel >= 5 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/funnel/relatorio",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/funnel/relatorio">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Company Assessment Funil
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::2 Level*/}

                  {/*begin::1 Level*/}
                  {userAcessLevel >= 1 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/farol",
                        false,
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/farol/0/0">
                        {/* <span className="svg-icon menu-icon">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Files/User-folder.svg")} />
                            </span> */}
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Farol</span>
                      </NavLink>
                    </li>
                  )}
                  {/*end::1 Level*/}
                </ul>
              </div>
            </li>
          )}

          {userAcessLevel >= 7 && (
            <li
              className={`menu-item ${getMenuItemActive("/gallery", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/gallery">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Files/Pictures1.svg")}
                  />
                </span>
                <span className="menu-text">Banco de imagens</span>
              </NavLink>
            </li>
          )}

          {userAcessLevel >= 1 && (
            <li
              className={`menu-item ${getMenuItemActive("/approval", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/approval">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                  />
                </span>
                <span className="menu-text">Fluxo de Aprovação</span>
              </NavLink>
            </li>
          )}

          {userAcessLevel >= 3 && (
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/contributors",
                true,
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/">
                {/* margin-right: -26px; margin-left: -15px; */}
                <span
                  style={{ marginRight: "-26px", marginLeft: "-9px" }}
                  className="svg-icon menu-icon"
                >
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                  />
                </span>
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                  />
                </span>
                <span
                  style={{ marginLeft: "-26px", marginRight: "-9px" }}
                  className="svg-icon menu-icon"
                >
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                  />
                </span>
                <span className="menu-text">Colaboradores</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">Colaboradores</span>
                    </span>
                  </li>
                  {userAcessLevel >= 3 ? (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/contributors/list",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/contributors/list">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Gestão</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                  {userAcessLevel >= 9 ? (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/contributorsNational",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/ContributorsNational">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Gestão Nacional</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}

                  {userAcessLevel >= 3 ? (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/UXAnalitycs",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/UXAnalitycs">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">UX Analytics</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}

                  {userAcessLevel >= 3 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/paineladmin",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/paineladmin">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Painel do Admin</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 3 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/pendenciaadmin",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/pendenciaadmin">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Pendências do Admin</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}

          {userAcessLevel >= 7 && (
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/error",
                true,
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/General/Clipboard.svg",
                    )}
                  />
                </span>

                <span className="menu-text">Estrutura Organizacional</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">
                        Estrutura Organizacional
                      </span>
                    </span>
                  </li>

                  {userAcessLevel >= 7 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/StructureOrganizations",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/StructureOrganizations"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Gestão Estruturas</span>
                      </NavLink>
                    </li>
                  )}

                  {userAcessLevel >= 7 && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/costcenter",
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/costcenter">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Centros de Custo</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )}
          {/*Estrutura Organizacional FIM*/}

          {/*begin::1 Level*/}
          {userAcessLevel >= 2 && (
            <li
              className={`menu-item ${getMenuItemActive("/logs", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/logs">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Files/User-folder.svg",
                    )}
                  />
                </span>
                <span className="menu-text">Logs</span>
              </NavLink>
            </li>
          )}
          {/*end::1 Level*/}

          {userAcessLevel >= 10 ? (
            <li
              className={`menu-item ${getMenuItemActive("/rollout")}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to={`/rollout`}>
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/066-calendar-today.svg")} />
                </span>

                <span className="menu-text">Rollout Fábricas</span>
              </NavLink>
            </li>
          ) : (
            ""
          )}

          {userAcessLevel >= 7 ? (
            <li
              className={`menu-item ${getMenuItemActive("/biTicket")}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to={`/biTicket`}>
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Ticket.svg")}
                  />
                </span>

                <span className="menu-text">BI Tickets</span>
              </NavLink>
            </li>
          ) : (
            ""
          )}
        </ul>

        {/* end::Menu Nav */}

        <div className="d-flex justify-content-around">
          <div className="version">V {version}</div>
          <div className="dateversion">{dateVersion}</div>
        </div>
      </>
    </>
  );
}
